import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IHomeIconProps extends ISvgIconProps {

}

export class HomeIcon extends React.Component<IHomeIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M17.561,20h-3.935c-0.48,0-0.871-0.391-0.871-0.87v-3.577h-1.512v3.577c0,0.479-0.391,0.87-0.871,0.87H6.438
                        c-0.48,0-0.871-0.391-0.871-0.87v-6.15H4.821c-0.508,0-0.955-0.306-1.138-0.779C3.5,11.726,3.624,11.2,3.999,10.858l7.178-6.538
                        c0.469-0.427,1.176-0.427,1.645,0l1.12,1.021c0.158-0.224,0.419-0.371,0.713-0.371h3.254c0.48,0,0.871,0.39,0.871,0.87v3.905
                        l1.221,1.112c0.375,0.342,0.499,0.869,0.316,1.342c-0.185,0.474-0.632,0.78-1.139,0.78h-0.746v6.15
                        C18.433,19.61,18.042,20,17.561,20z M10.444,14.752h3.113v4.378l4.005,0.069l0.07-7.02h1.547c0.178,0,0.328-0.103,0.393-0.269
                        c0.062-0.162,0.02-0.344-0.109-0.462l-1.482-1.35V5.841l-3.324-0.07l-0.07,0.332v0.906l-2.302-2.097
                        c-0.162-0.148-0.407-0.147-0.567,0L4.538,11.45c-0.131,0.119-0.173,0.296-0.109,0.462c0.063,0.163,0.217,0.268,0.392,0.268h1.546
                        v6.95l4.005,0.069L10.444,14.752z"/>
                </g>
            </SvgIcon>
        );
    }
}
